// extracted by mini-css-extract-plugin
export default {"experience":"Experience_experience__oSsWu"};